import { MAIN_PHONE_NUMBER } from '@constants/index'
import { usePageSettings } from '@providers/page-settings'
import { useNodeParams } from 'admin/hooks/useNodeParams'
import { AvailableComponentTypes, AvailablePageNodes } from 'admin/types'

export const SEO = () => {
	const { admin: { page: { name, pageNode } = {} } = {} } = usePageSettings()
	const mainBlock = pageNode?.find(({ name }) => name === AvailablePageNodes.main_block)
	const mainBlockData = useNodeParams(mainBlock?.nodeParam ?? [])
	const [image, description, stringArray = '']: string[] = [
		mainBlockData.get(AvailableComponentTypes.url),
		mainBlockData.get(AvailableComponentTypes.description),
		mainBlockData.get(AvailableComponentTypes.stringArray),
	]

	if (!mainBlock) return null

	return (
		<div hidden itemScope itemType='https://schema.org/Service'>
			<h1 itemProp='serviceType'>{name}</h1>
			<div itemProp='provider' itemScope itemType='https://schema.org/Organization'>
				<span itemProp='name'>Credit.Club</span>
				<span itemProp='telephone'>{MAIN_PHONE_NUMBER}</span>
				<span itemProp='url'>https://credit.club</span>
			</div>
			<div itemProp='description'>
				{description}{' '}
				{stringArray.split('\n').map((item, index) => (
					<span key={index}>{item}</span>
				))}
			</div>
			<img src={image} itemProp='image' alt={name} />
		</div>
	)
}
